/**
 * @generated SignedSource<<282b8d584f78cad474a22040311fa51c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ExternalMembershipType = "PRIVATE" | "PUBLIC" | "SHARED" | "%future added value";
export type SearchLinkedEntitiesType = "comments" | "messages" | "thread" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphMessage_AtlassianSearchPage$data = {
  readonly attachments: ReadonlyArray<{
    readonly __typename: "SearchResultGraphAttachment";
  }> | null;
  readonly entity: {
    readonly attachments?: ReadonlyArray<{
      readonly __typename: "ExternalAttachment";
    } | null> | null;
    readonly container?: {
      readonly id?: string;
      readonly memberCount?: AGG$Long | null;
      readonly membershipType?: ExternalMembershipType | null;
    } | null;
    readonly description?: string | null;
    readonly lastActive?: string | null;
    readonly reactionCount?: number | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly integrationId: string | null;
  readonly lastModifiedDate: string | null;
  readonly linkedEntities: ReadonlyArray<{
    readonly entity: {
      readonly description?: string | null;
    } | null;
    readonly excerpt: string | null;
  }> | null;
  readonly linkedEntitiesType: SearchLinkedEntitiesType | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly links: ReadonlyArray<string> | null;
  readonly topReaction?: {
    readonly count: number;
    readonly emojiName: string;
    readonly emojiUrl: string | null;
  } | null;
  readonly url: string;
  readonly workspaceName?: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"attachmentItems_AtlassianSearchPage_DropdownItems" | "attachments_AtlassianSearchPage" | "threadBody_AtlassianSearchPage" | "threadTitle_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphMessage_AtlassianSearchPage";
};
export type searchGraphMessage_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphMessage_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphMessage_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "description"
},
v6 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphMessage_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "attachmentItems_AtlassianSearchPage_DropdownItems"
    },
    {
      "kind": "FragmentSpread",
      "name": "attachments_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "threadTitle_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "threadBody_AtlassianSearchPage"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "links"
    },
    {
      "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SearchSlackReaction",
          "kind": "LinkedField",
          "name": "topReaction",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "emojiName"
            },
            {
              "kind": "ScalarField",
              "name": "emojiUrl"
            },
            {
              "kind": "ScalarField",
              "name": "count"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchResultGraphAttachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": (v4/*: any*/)
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v5/*: any*/)
              ],
              "type": "ExternalMessage"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "linkedEntitiesType"
    },
    (v6/*: any*/),
    {
      "condition": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "workspaceName"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lastActive"
            },
            {
              "kind": "ScalarField",
              "name": "reactionCount"
            },
            (v5/*: any*/),
            {
              "concreteType": "ExternalAttachment",
              "kind": "LinkedField",
              "name": "attachments",
              "plural": true,
              "selections": (v4/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "memberCount"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "membershipType"
                    }
                  ],
                  "type": "ExternalConversation"
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "title"
        },
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        (v5/*: any*/),
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "7004d9865b7a39eeb450a34cbd369325";

export default node;
